import { MessageType } from './message-type';

export class SocialNetworkMessage {
  public type: MessageType;
  public content: string;
  public lastName: string;
  public firstName: string;
  public customerId: string | undefined;
  public csrId: string | undefined;
  public token: string | undefined;
  public extraMap: Map<string, string> | undefined;
  public contactId: string | undefined;
  public contactFlowUri: string | undefined;
  public date: number | undefined;

  constructor(
    type: MessageType,
    content: string,
    lastName: string,
    firstName: string,
    customerId?: string,
    csrId?: string,
    date: number = 0,
    token?: string,
    extraMap?: Map<string, string>,
    contactId?: string,
    contactFlowId?: string
  ) {
    this.type = type;
    this.content = content;
    this.lastName = lastName;
    this.firstName = firstName;
    this.customerId = customerId;
    this.csrId = csrId;
    this.date = date || Date.now();
    this.token = token;
    this.extraMap = extraMap;
    this.contactId = contactId;
    this.contactFlowUri = contactFlowId;
  }

  public static fromWebSocket(o: any) {
    return new SocialNetworkMessage(
      o.type,
      o.content,
      o.lastName,
      o.firstName,
      o.customerId,
      o.csrId,
      o.date,
      o.token,
      o.extraMap,
      o.contactId,
      o.contactFlowUri
    );
  }

  public isFromCustomer(): boolean {
    return this.csrId === null || this.csrId === undefined;
  }
}
